import React, { Component } from 'react';
import { connect } from "react-redux";
import CustomSearchableSelectWrapper from '../../../common/custom-form/custom-searchable-select-wrapper.component';
import {
    EXTRACT_TEMPLATE_MODULES,
    FILE_NAME_TEMPLATE,
    MAX_LENGTH,
    RATE_CARD_UPLOAD_TYPES,
    RATE_CARD_UPLOAD_TYPE_MESSAGE,
    RATE_CARD_FILE_LIMITATION,
    UPLOAD_TYPES,
    DOWNLOAD_TEMPLATE_lABEL
} from '../../../../constants/external-constants';
import ButtonIcon from "../../../../components/button";
import { Button } from 'react-bootstrap';
import Translation from '../../../common/translation/translation.component';
import "../finance.css";
import { bindActionCreators } from 'redux';
import DragDropUpload from '../../../common/upload/drag-drop-upload/drag-drop-upload.component';
import { TRANSLATIONS } from '../../../../utils/constant.utils';
import { MODAL_CUSTOM_MESSAGE } from '../../../../constants/external-constants';
import { RateCardUploadAction } from '../../../../store/external/finance/rate-card-upload.reducer';
import { SelectFieldFloatingLabel } from '../../../common/custom-form/select-filter.component';
import { Loading } from '../../../common/loading/index';

class RateCardUploadView extends Component{

    constructor(props) {
        super(props);

        this.childRef = React.createRef();

        this.state = {
            vendor: null,
            extractAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            uploadInProgress: false,
            uploadInProgress: false,
            isLoading: true,
            filterLoading: false,
            loadingLabel: "",
            errorModal: {
                show: false,
                title: "",
                message: ""
            },
        };
    }

    async componentDidMount() {
        const { getVendorDetails, getRateCardUploadTypes, resetRateCardUploadForm } = this.props;
        await resetRateCardUploadForm();
        await getVendorDetails().then(() => { this.setState({ isLoading: false })});
        await getRateCardUploadTypes().then(() => {this.setState({ isLoading: false })});
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];

        return TRANSLATIONS[locale][key];
    }

    handleChangeVendor = (Id) => {
        this.setState({
            vendor: Id
        });
    }
    onClickDownload = () => {
        if (window.confirm(this.state.extractAlertMsg)) {
            //this.props.extractInventoryCircuits(id);
        }
    }
    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    dropDragDisable = () => {
        const { rateCardUploadForm } = this.props;
        const requiredField = !(rateCardUploadForm.vendorId && rateCardUploadForm.rateCardUploadTypeId);

        return requiredField;
    }

    handleDownloadTemplate = () => {
        const { downloadRateCardUploadTemplate } = this.props;
        this.setState({
            filterLoading: true,
            loadingLabel: "Downloading"
        })
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            downloadRateCardUploadTemplate(EXTRACT_TEMPLATE_MODULES.rateCardUploadTemplate, FILE_NAME_TEMPLATE.rateCardUploadTemplate).then(() => {
                this.setState({
                    filterLoading: false,
                    loadingLabel: ""
                })
            });;
        } else {
            this.setState({
                filterLoading: false,
                loadingLabel: ""
            })
        } 
    }

    handleSuccessProcess = (data) => {
        const { postExecuteProcess } = this.props;
        postExecuteProcess(data.UploadId);
        this.setState({
            uploadInProgress: false
        });
    }

    handleAddFiles = () => {
        this.forceUpdate();
    }

    handleRemoveFiles = () => {
        this.forceUpdate();
    }

    djsConfigParams = () => {
        const { rateCardUploadForm } = this.props;
        const { vendorOptions } = this.props.rateCardUpload;

        var baseParams = {
            VendorDetailId: rateCardUploadForm.vendorId,
            VendorName: vendorOptions?.find(i => i.Key == rateCardUploadForm.vendorId)?.Value.replace('[Preferred]', '').trim(),
            RateCardUploadTypeId: rateCardUploadForm.rateCardUploadTypeId
        };

        var djsConfig = {
            params: {
                CreatedBy: sessionStorage.getItem('EID').toString(),
                UserId: sessionStorage.getItem('UserID').toString(),
                UploadTypeId: UPLOAD_TYPES.RateCardUpload,
                VendorName: vendorOptions?.find(i => i.Key == rateCardUploadForm.vendorId)?.Value.replace('[Preferred]', '').trim(),
                ChargeTypeDetails: JSON.stringify({
                    ...baseParams,
                }), 
            },
            maxFiles: RATE_CARD_FILE_LIMITATION.maxFiles,
            minFiles: RATE_CARD_FILE_LIMITATION.minFiles,
            acceptedFiles: RATE_CARD_FILE_LIMITATION.acceptedFiles,
            dictInvalidFileType: this.toLocaleLanguage('error_invalid_file_type'),
            dictMaxFilesExceeded: this.toLocaleLanguage('error_exceeded_maximum_file'),
            dictErrorOccured: this.toLocaleLanguage('error_occured_reupload_file')
        };

        return djsConfig;
    }

    disabledUpload = () => {
        const { rateCardUploadForm } = this.props;
        const intialField = !(!rateCardUploadForm.vendorId && !rateCardUploadForm.rateCardUploadTypeId);

        let validFiles = false;
        if (this.childRef.current) {
            validFiles = this.childRef.current.checkValidFileForm();
        }

        return !(intialField && validFiles);
    }

    handleUpload = () => {
        if (this.childRef.current) {
            this.childRef.current.processQueue();
        }
        this.setState({
            uploadInProgress: true
        });
    }

    onErrorUpload = () => {
        this.setState({
            uploadInProgress: false
        })
    }

    render() {

        const { rateCardUploadForm, onVendorSelect, onRateCardTypeSelect } = this.props;
        const { vendorOptions, rateCardUploadTypeOptions } = this.props.rateCardUpload
        return (
            <div className="rate-card-upload upload__container ">
                {
                    this.state.filterLoading &&
                    <Loading customClass="filter-loading" label={this.state.loadingLabel} />
                }
                <div className="invoice-mapping-container">
                    <div className="field-section">
                        <div className="field-content">

                            <Translation
                                getOnlyText={true}
                                onChangeTranslation={this.onChangeExtractAlertMsg}
                                translationKey={"export_alert_message"} />
                            <CustomSearchableSelectWrapper
                                label={`${this.toLocaleLanguage('vendor')}`}
                                options={vendorOptions}
                                selected={rateCardUploadForm.vendorId}
                                onChange={(e) => onVendorSelect('rateCardUploadForm.vendorId', e)}
                                requiredField
                                placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                fieldProp='rateCardUploadForm.vendorId'
                                tagName='VendorDetailId'
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                maxLength={MAX_LENGTH.limit_255}
                            />
                            <div className="spacer" />
                            <SelectFieldFloatingLabel
                                className="form-select required"
                                label={`${this.toLocaleLanguage('upload_type')}`}
                                options={rateCardUploadTypeOptions}
                                value={rateCardUploadForm.rateCardUploadTypeId ?? ""}
                                placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                isError={false}
                                fieldProp='rateCardUploadForm.rateCardUploadTypeId'
                                onChangeAction={onRateCardTypeSelect}
                                optionLabelKey={{
                                    Key: "Key",
                                    Value: "Value"
                                }}
                            />

                            {rateCardUploadForm.rateCardUploadTypeId === RATE_CARD_UPLOAD_TYPES.New ?
                                <span className="pending-upload-message">{RATE_CARD_UPLOAD_TYPE_MESSAGE.New}</span> : null
                            }

                            {rateCardUploadForm.rateCardUploadTypeId === RATE_CARD_UPLOAD_TYPES.Add ?
                                <span className="pending-upload-message">{RATE_CARD_UPLOAD_TYPE_MESSAGE.Add}</span> : null
                            }

                            <div className="spacer" />

                        </div>
                    </div>

                    <div className="upload-section">
                        <div className="upload-content">
                            <DragDropUpload
                                ref={this.childRef}
                                buttonLabel={DOWNLOAD_TEMPLATE_lABEL.rate_card_upload}
                                disabled={this.dropDragDisable()}
                                downloadButton={this.handleDownloadTemplate}
                                djsConfigParams={this.djsConfigParams()}
                                onSuccessProcess={this.handleSuccessProcess}
                                onAddFiles={this.handleAddFiles}
                                onRemoveFiles={this.handleRemoveFiles}
                                uploadTypeId={UPLOAD_TYPES.RateCardUpload}
                                onErrorUpload={this.onErrorUpload}
                            />
                        </div>
                    </div>

                    <div className="upload-btn-section">
                        <div className="save-btn-container">
                            <Button disabled={this.disabledUpload() || this.state.uploadInProgress} onClick={this.handleUpload} className="save-details-btn">Upload</Button>
                        </div>
                    </div>

                </div>
            </div>

        );
    }

}
   

export default connect(
    state => {
        const {
            translation,
            rateCardUpload
        } = state;

        const { rateCardUploadForm } = state.form;

        return {
            translation,
            rateCardUpload,
            rateCardUploadForm
        }
    },
    dispatch => bindActionCreators(
        Object.assign({}, RateCardUploadAction),
        dispatch
    )
)(RateCardUploadView);